<i18n
  src="@/locales/views/organization/production/query_by_producers/show_harvested_batch.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_package.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_exp_package.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/crop_har_package.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('show_producer_details')"
    :params="{
      organization_id: organization_id,
      harvest_process_id: harvest_process_id,
      producer_id: producer_id,
      provider_type: provider_type
    }"
  />
  <bread-crumbs :labels="[module_name, harvest_process.name, producer]" />
  <template v-if="load_data_general">
    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>
        <div class="panel-body">
          <div class="space-y-8 divide-y divide-slate-200">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-2">
              <div class="sm:col-span-1 grid gap-y-6 gap-x-4">
                <div>
                  <dt class="label-data">
                    {{ $t("model.harvested_batch.batch_code") }}
                  </dt>
                  <dd class="content-data">
                    {{ harvested_batch.batch_code }}
                  </dd>
                </div>
                <div>
                  <dt class="label-data">
                    {{ $t("model.harvested_batch.registered_at") }}
                  </dt>
                  <dd class="content-data">
                    {{
                      dateFormatter(harvested_batch.registered_at)
                    }}
                  </dd>
                </div>
                <!-- <div -->
                <!--   v-if=" -->
                <!--     provider_type == 'organization' || -->
                <!--     harvested_batch.organization -->
                <!--   " -->
                <!-- > -->
                <!--   <dt class="label-data"> -->
                <!--     {{ $t("model.harvested_batch.organization") }} -->
                <!--   </dt> -->
                <!--   <dd class="content-data"> -->
                <!--     {{ harvested_batch.organization?.name }} -->
                <!--   </dd> -->
                <!-- </div> -->
                <div
                  v-if="provider_type == 'producer' || harvested_batch.producer"
                >
                  <dt class="label-data">
                    {{ $t("model.harvested_batch.producer") }}
                  </dt>
                  <dd class="content-data">
                    {{ producer_label }}
                  </dd>
                </div>
                <div>
                  <dt class="label-data">
                    {{ $t("model.harvested_batch.crop_field") }}
                  </dt>
                  <dd class="content-data">
                    {{ harvested_batch.crop_field?.name }}
                  </dd>
                </div>
                <div v-if="harvested_batch.harvested_packages.length > 0">
                  <dt class="label-data">
                    {{ $t("model.harvested_batch.harvested_packages") }}
                  </dt>
                  <dd class="content-data">
                    <template
                      v-for="(
                        { number, crop_har_package }, idx
                      ) in Object.values(harvested_batch.harvested_packages)"
                      :key="idx"
                    >
                      {{ number }} {{ crop_har_package.name }}
                    </template>
                  </dd>
                </div>
                <div>
                  <dt class="label-data">
                    {{ $t("model.harvested_batch.total_weight") }}
                  </dt>
                  <dd class="content-data">
                    {{ harvested_batch?.total_weight }}
                  </dd>
                </div>
                <div>
                  <dt class="label-data">
                    {{ $t("model.harvested_batch.discarded_weight") }}
                  </dt>
                  <dd class="content-data ">
                    {{ harvested_batch?.discarded_weight }}
                  </dd>
                </div>

                <div>
                  <dt class="label-data">
                    {{ $t("labels.percents") }}
                  </dt>
                  <dd class="content-data mr-48 py-4">
                    <percent-bar
                      :ok_percent="ok_percent"
                      :err_percent="discarded_percent"
                      min_width="full"
                    />
                  </dd>
                </div>
              </div>
              <div
                class="sm:col-span-1"
                v-if="crop_field.latitude_dd && crop_field.longitude_dd && false"
              >
                <google-map
                  :lat="crop_field.latitude_dd"
                  :lng="crop_field.longitude_dd"
                  :title="crop_field.name"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- harvested_package -->
    <div class="mt-8 flex flex-row justify-between">
      <h1 class="page-title">
        <i class="fa-solid fa-box"></i>
        <span class="space-icon"></span>
        {{ $t("labels.title_packages") }}
      </h1>
    </div>
    <div class="mt-6 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_exp_package.crop_exp_package") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_exp_package.crop_category") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_exp_package.crop_size") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_exp_package.number") }}
                  </th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="harvested_exp_package in harvested_batch.harvested_exp_packages"
                  :key="harvested_exp_package.id"
                >
                  <td class="table-cell">
                    {{ harvested_exp_package.crop_exp_package.name }}
                  </td>
                  <td class="table-cell">
                    {{ harvested_exp_package.crop_category.name }}
                  </td>
                  <td class="table-cell">
                    {{ harvested_exp_package.crop_size.name }}
                  </td>
                  <td class="table-cell">
                    {{ harvested_exp_package.number }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/organization/requesters/production/query_by_producers/show_harvested_batch.js";
import GoogleMap from "@/components/views/layout/GoogleMap.vue";
import PercentBar from "@/components/views/layout/PercentBar.vue";

export default {
  name: "OrgProcessPackingShowHarvestedBatch",
  components: {
    GoogleMap,
    PercentBar
  },
  data() {
    return {
      load_data_general: false,
      harvest_process: {},
      harvested_batch: {}
    };
  },
  props: {
    organization_id: { required: true },
    harvest_process_id: { required: true },
    harvested_batch_id: { required: true },
    producer_id: { required: true },
    provider_type: { required: true }
  },
  computed: {
    producer_label: function () {
      if (this.harvested_batch.producer?.producer_code) {
        return `${this.harvested_batch.producer.producer_code} - ${this.harvested_batch.producer?.fullname}`;
      } else {
        return this.harvested_batch.producer?.fullname;
      }
    },
    producer: function () {
      if (this.provider_type == "producer")
        return this.harvested_batch.producer?.fullname;

      if (this.provider_type == "organization")
        return this.harvested_batch.organization?.name;

      return "";
    },
    crop_field: function () {
      return {
        latitude_dd: Number(this.harvested_batch.crop_field?.latitude_dd),
        longitude_dd: Number(this.harvested_batch.crop_field?.longitude_dd),
        name: this.harvested_batch.crop_field?.name
      };
    },
    ok_percent: function () {
      return this.harvested_batch.total_weight > 0
        ? ((this.harvested_batch.total_weight - this.harvested_batch.discarded_weight) /
          this.harvested_batch.total_weight) *
        100
        : 0;
    },
    discarded_percent: function () {
      return this.harvested_batch.total_weight
        ? (this.harvested_batch.discarded_weight / this.harvested_batch.total_weight) *
          100
        : 0;

    }
    // harvested_batch: function () {
    //   const harvested_batches = this.harvested_batch.harvested_batches;
    //   let harvested_batch = {
    //     total_weight: harvested_batches.reduce(
    //       (acc, harvested_batch) => acc + Number(harvested_batch.total_weight),
    //       0
    //     ),
    //     discarded_weight: harvested_batches.reduce(
    //       (acc, harvested_batch) =>
    //         acc + Number(harvested_batch.discarded_weight),
    //       0
    //     ),
    //     harvested_packages: harvested_batches
    //       .map(harvested_batch => harvested_batch.harvested_packages)
    //       .flat()
    //       .reduce((acc, harvested_package) => {
    //         const key = harvested_package.crop_har_package.id;
    //         if (!acc[key]) {
    //           acc[key] = {
    //             crop_har_package: harvested_package.crop_har_package.name,
    //             number: 0
    //           };
    //         }
    //         acc[key].number += harvested_package.number;
    //         return acc;
    //       }, {})
    //   };
    //   harvested_batch["ok_percent"] =
    //     harvested_batch.total_weight > 0
    //       ? ((harvested_batch.total_weight - harvested_batch.discarded_weight) /
    //           harvested_batch.total_weight) *
    //         100
    //       : 0;
    //   harvested_batch["discarded_percent"] = harvested_batch.total_weight
    //     ? (harvested_batch.discarded_weight / harvested_batch.total_weight) *
    //       100
    //     : 0;
    //
    //   return harvested_batch;
    // }
  },
  methods: {
    loadData: async function () {
      await this.fetchHarvestProcess();
      await this.fetchHarvestedBatch();
      this.load_data_general = true;
    },
    fetchHarvestProcess: async function () {
      let response = await Requester.fetchHarvestProcess(
        this.organization_id,
        this.harvest_process_id
      );
      this.harvest_process = response.data;
    },
    fetchHarvestedBatch: async function () {
      let response = await Requester.fetchHarvestedBatch(
        this.organization_id,
        this.harvested_batch_id
      );
      this.harvested_batch = response.data;
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => this.loadData())
    );
  }
};
</script>
